<script setup>
import { useFutureStore } from '~/store/future'

const { t } = useI18n()
const future = useFutureStore()
const unit = ref(future.unit)
const ul = computed(() => [
  { title: `${t('合约张数')}-${t('张')}`, key: 'lot', des: t('标的资产的市场价值使用时，开仓成本会根据杠杆进行变化') },
  { title: `${t('数量单位')}-${future.base}`, key: 'base', des: t('请您填写合约数量，单位为{0}。', [future.base]) },
  // { title: `${t('valueUnit')}-${future.quote}`, key: 'cost', des: t('valueUnitDes') },
  // { title: `${t('nominalUnit')}-${future.quote}`, key: 'quote', des: t('nominalUnitDes') },
])
function ok() {
  future.updateUnit(unit.value)
  return true
}
function onEnter() {
  unit.value = future.unit
}
</script>

<template>
  <CommonXModal :ok="ok" :title="$t('合约单位设置')" @after-enter="onEnter">
    <ul class="space-y-4">
      <li v-for="item in ul" :key="item.key" :class="{ 'border-textPrimary': unit === item.key }" class="relative flex flex-col p-4 border rounded-lg cursor-pointer border-border" @click="unit = item.key">
        <span class="font-bold">{{ item.title }}</span>
        <span class="mt-1.5 text-xs leading-5">{{ item.des }}</span>
        <i :class="{ '!flex': unit === item.key }" class="absolute bottom-0 right-0 items-center justify-center hidden w-5 h-5 bg-textPrimary rounded-br-[6px] rounded-tl-md">
          <SvgoCommonCheck class="w-2.5 h-2 text-textOnBtn" />
        </i>
      </li>
    </ul>
  </CommonXModal>
</template>
